import { RootState } from 'app/store';

// is alive
export const selectLeasingCalculatorIsAlive = (state: RootState) =>
  state.leasingCalculator.isAlive.result;

// premade products data
export const selectPremadeProductsLoading = (state: RootState) =>
  state.leasingCalculator.premadeProducts?.loading;

export const selectPremadeProducts = (state: RootState) =>
  state.leasingCalculator.premadeProducts?.content;

export const selectPremadeProductsTotalPageCount = (state: RootState) =>
  state.leasingCalculator.premadeProducts?.totalPageCount;

// product selection data
export const selectProductSelectionDataLoading = (state: RootState) =>
  state.leasingCalculator.productSelectionData.loading;

export const selectProductSelectionDataResult = (state: RootState) =>
  state.leasingCalculator.productSelectionData.result;

export const selectProductSelectionDataError = (state: RootState) =>
  state.leasingCalculator.productSelectionData.error;

// offer data
export const selectOfferDataLoading = (state: RootState) =>
  state.leasingCalculator.offerData.loading;
